module.exports = __webpack_public_path__ + "af3fc1cf1f748105e051201a78561658.pdf";